<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container mt-5">
  <!-- Members -->
  <div class="row">
    <ng-container *ngFor="let instructor of instructors">
      <div class="col-md-6 col-sm-6 col-12 col-lg-4 col-xl-3">
        <div class="card text-center mb-5 mr-1">
          <div class="card-body pt-6 pb-6 pl-2 pr-2">
            <!-- Team -->
            <div class="mb-4">
              <div class="position-relative u-xl-avatar mx-auto mb-3">
                <img class="img-fluid rounded-circle" width="200px"  [fallback]="'fetch-avatar?userId=' + instructor.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ instructor.id }}-avatar.png"  />
              </div>

              <h2 class="h6 mb-0">
                <a [routerLink]="['../instructors', instructor.slug]">{{ instructor.fullName }}</a>
              </h2>
              <a class="small" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis" [routerLink]="['../instructors', instructor.slug]">{{ instructor.credentials | truncate:20 }}&nbsp;</a>
            </div>
            <!-- End Team -->
          </div>

          <div class="card-footer py-4">
            <a class="btn btn-sm btn-soft-primary transition-3d-hover" [routerLink]="['../instructors', instructor.slug]">
              <span class="fas fa-info-square mr-2"></span>
              View Details
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
